var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.walletGate)?_c('WalletRequired'):[_c('router-view'),_c('AnnouncementPopup')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }